import {
  AdministrationMenu,
  CommissionsMenu,
  EndorsementsMenu,
  RiskManagementMenu,
  UtilitiesMenu,
} from './menus';
import { ITabRoutes } from '../util/TabListToRouteList';
import { useUserPermissions } from './useUserPermissions';
import { LrpTeamMenu } from './menus/LrpTeamMenu';
import { MidOfficeMenu } from './menus/MidOfficeMenu';

export type SubMenu = {
  title: string;
  path: string;
  element: React.ReactElement;
  // A list shows the item when the user holds any of them (Administration > Integrations)
  permission: string | string[];
  hidden?: boolean;
  children?: ITabRoutes[];
};

export type Menu = {
  menuTitle: string;
  path: string;
  icon?: React.ReactElement;
  subMenus: SubMenu[];
};

// The Role form's Resources tree lists menu items in this order too, sorted by web.Resources.DisplayOrder.
// Adding or reordering a menu here, or an item in a menu file's subMenus, needs a migration that
// renumbers DisplayOrder to match (see _15614_custom_resource_display_order). An item behind several
// resources (Integrations) takes one DisplayOrder per resource, in its permission list's order.
const menus: Menu[] = [
  ...RiskManagementMenu,
  ...EndorsementsMenu,
  ...LrpTeamMenu,
  ...MidOfficeMenu,
  ...CommissionsMenu,
  ...UtilitiesMenu,
  ...AdministrationMenu,
];



export function useCasFilteredNavigation() {
  const { userHasPermission } = useUserPermissions();

  const filteredMenu = menus
    .map((section) => ({
      ...section,
      subMenus: section.subMenus
        .filter((subMenu) => [subMenu.permission].flat().some(userHasPermission))
        .map((subMenu) => {
          const fullPath = `/${section.path}/${subMenu.path}`;
          return {
            ...subMenu,
            path: fullPath, 
          };
      }),
    }))
    .filter((section) => section.subMenus.length > 0); // Filter out sections with no subMenus

  return filteredMenu;
}
